import { flattenTranslations } from "./utils/flatten.js";
import { findLocaleKeys, getLocaleKey, hasRegisteredLocale } from "./registry.js";
//#region src/core/i18n/load-locale.ts
const loaders = {
	ar: () => import("../../i18n/locales/ar.js"),
	az: () => import("../../i18n/locales/az.js"),
	bs: () => import("../../i18n/locales/bs.js"),
	bg: () => import("../../i18n/locales/bg.js"),
	bn: () => import("../../i18n/locales/bn.js"),
	ca: () => import("../../i18n/locales/ca.js"),
	cs: () => import("../../i18n/locales/cs.js"),
	cy: () => import("../../i18n/locales/cy.js"),
	da: () => import("../../i18n/locales/da.js"),
	de: () => import("../../i18n/locales/de.js"),
	el: () => import("../../i18n/locales/el.js"),
	es: () => import("../../i18n/locales/es.js"),
	et: () => import("../../i18n/locales/et.js"),
	eu: () => import("../../i18n/locales/eu.js"),
	fa: () => import("../../i18n/locales/fa.js"),
	fi: () => import("../../i18n/locales/fi.js"),
	fr: () => import("../../i18n/locales/fr.js"),
	gd: () => import("../../i18n/locales/gd.js"),
	gl: () => import("../../i18n/locales/gl.js"),
	he: () => import("../../i18n/locales/he.js"),
	hi: () => import("../../i18n/locales/hi.js"),
	hr: () => import("../../i18n/locales/hr.js"),
	hu: () => import("../../i18n/locales/hu.js"),
	id: () => import("../../i18n/locales/id.js"),
	it: () => import("../../i18n/locales/it.js"),
	ja: () => import("../../i18n/locales/ja.js"),
	ko: () => import("../../i18n/locales/ko.js"),
	lt: () => import("../../i18n/locales/lt.js"),
	lv: () => import("../../i18n/locales/lv.js"),
	mr: () => import("../../i18n/locales/mr.js"),
	nb: () => import("../../i18n/locales/nb.js"),
	nl: () => import("../../i18n/locales/nl.js"),
	nn: () => import("../../i18n/locales/nn.js"),
	ne: () => import("../../i18n/locales/ne.js"),
	oc: () => import("../../i18n/locales/oc.js"),
	pl: () => import("../../i18n/locales/pl.js"),
	"pt-br": () => import("../../i18n/locales/pt-BR.js"),
	"pt-pt": () => import("../../i18n/locales/pt-PT.js"),
	ro: () => import("../../i18n/locales/ro.js"),
	ru: () => import("../../i18n/locales/ru.js"),
	sk: () => import("../../i18n/locales/sk.js"),
	sl: () => import("../../i18n/locales/sl.js"),
	sr: () => import("../../i18n/locales/sr.js"),
	sv: () => import("../../i18n/locales/sv.js"),
	te: () => import("../../i18n/locales/te.js"),
	th: () => import("../../i18n/locales/th.js"),
	tr: () => import("../../i18n/locales/tr.js"),
	uk: () => import("../../i18n/locales/uk.js"),
	vi: () => import("../../i18n/locales/vi.js"),
	"zh-cn": () => import("../../i18n/locales/zh-CN.js"),
	"zh-tw": () => import("../../i18n/locales/zh-TW.js"),
	pt: () => import("../../i18n/locales/pt.js"),
	zh: () => import("../../i18n/locales/zh.js")
};
/**
* Lazy-import the built-in locale pack for a tag, or its closest fallback in the {@link findLocaleKeys} chain. Resolves
* to `undefined` when that chain reaches a registered locale first or no built-in pack matches.
*
* @param tag - BCP 47 tag to load, such as `fr-CA`.
* @public
*/
async function loadLocale(tag) {
	if (hasRegisteredLocale(tag)) return void 0;
	for (const chainTag of findLocaleKeys(tag)) {
		if (hasRegisteredLocale(chainTag)) return void 0;
		const load = loaders[getLocaleKey(chainTag)];
		if (load) return flattenTranslations((await load()).default);
	}
}
//#endregion
export { loadLocale };

//# sourceMappingURL=load-locale.js.map